import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import English from './assets/locales/english.json';
import Deutsch from './assets/locales/deutsch.json';

i18n
.use(initReactI18next)
.init({
  resources: {
    en: {
      translation: English
    },
    de: {
      translation: Deutsch
    }
  },
  lng: "de", 
  fallbackLng: "de",
  interpolation: {
    escapeValue: false
  }
});